/**
 * Header over content (style.css): marks the body once the page has scrolled,
 * so the transparent header gets its background back, and hides the header
 * while scrolling down, bringing it back on the way up.
 */
const OVERLAY_CLASS = 'r2o-header-overlay';
const SCROLLED_CLASS = 'r2o-scrolled';
const HIDDEN_CLASS = 'r2o-header-hidden';

// Ignore scroll jitter smaller than this, in pixels.
const MIN_DELTA = 4;

const header = document.querySelector( '.elementor-location-header' );

if ( header && document.body.classList.contains( OVERLAY_CLASS ) ) {
	let lastY = window.scrollY;

	// Never hide what someone is using: keyboard focus or an open menu. A
	// mouse click also leaves focus behind, so only :focus-visible counts.
	const isInUse = () =>
		header.querySelector( ':focus-visible, [aria-expanded="true"]' ) !==
		null;

	const update = () => {
		const y = window.scrollY;
		const { classList } = document.body;

		classList.toggle( SCROLLED_CLASS, y > 0 );

		if ( Math.abs( y - lastY ) < MIN_DELTA ) {
			return;
		}

		const goingDown = y > lastY && y > header.offsetHeight;
		classList.toggle( HIDDEN_CLASS, goingDown && ! isInUse() );
		lastY = y;
	};

	update();
	window.addEventListener( 'scroll', update, { passive: true } );
	header.addEventListener( 'focusin', () => {
		if ( isInUse() ) {
			document.body.classList.remove( HIDDEN_CLASS );
		}
	} );
}

/*
 * A mega-menu panel opened on hover stays open while the pointer rests on it,
 * so a link to a section of the same page (the footer newsletter) would scroll
 * under the panel. Escape is the menu's own way to close a panel from a link
 * inside it.
 */
header?.addEventListener( 'click', ( event ) => {
	const link = event.target.closest( '.e-n-menu-content a[href^="#"]' );

	if ( link ) {
		link.dispatchEvent(
			new window.KeyboardEvent( 'keydown', {
				key: 'Escape',
				bubbles: true,
			} )
		);
	}
} );
